var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-top p-2"},[_c('b-row',[(_vm.noNotifications)?_c('b-col',[_c('p',[_vm._v("\n        "+_vm._s(_vm.$t('TL_NO_EXPORTS_NO_EXPORTS_PROCESSING'))+"\n      ")])]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }